'use strict';

import State, { IContractsDictionaries } from './state';
import StandardDictionaryItem from '@core/js/ddriven/domain/model/common/dictionaries/StandardDictionaryItem.valueobject';
import ExtendedDictionaryItem from '@core/js/ddriven/domain/model/common/dictionaries/ExtendedDictionaryItem.valueobject';

const getters = {
    statuses: function (state: State): StandardDictionaryItem[] | null {
        return state.statuses;
    },
    statusesmenu: function (state: State): ExtendedDictionaryItem[] | null {
        return state.statusesmenu;
    },
    types: function (state: State): ExtendedDictionaryItem[] | null {
        return state.types;
    },
    all: function (state: State): Record<string, StandardDictionaryItem[] | ExtendedDictionaryItem[] | null> {
        return {
            statuses: state.statuses,
            // REFACTOR: Rename to menustatuses
            statusesmenu: state.statusesmenu,
            // REFACTOR: Rename to types
            types: state.types
        };
    }
};

export default getters;
